import { Component, forwardRef, Inject, OnInit } from '@angular/core';
import { DashboardCombiDataIndicator }           from '../../models/dashboard-combi-data-indicator';
import { DashboardCombiDataIndicatorMeta }       from '../../models/dashboard-combi-data-indicator-meta';
import { DashboardPanelComponentBase } from '@cs/components/shared';
import { PopoverRef }                            from '@cs/components/popover';
import { ArrayUtils }                            from '@cs/core';

@Component({
						 selector:    'cs-dashboard-list',
						 templateUrl: './dashboard-list.component.html',
						 standalone: false,
						 styles:      [
							 `
				   .dashboard-list-container {
					   min-width: 112px;
					   max-width: 165px;
				   }

				   ul {
					   padding-left: 0;
					   margin-bottom: 0;

					   list-style: none;
				   }

				   li {
					   padding: 0.5em 0.5em 0 0.5em;
				   }

				   label {
					   color: inherit;
					   font-weight: 500;
					   font-size: 12px;
					   margin-bottom: 0.5em;
				   }

				   small {
					   margin-right: 0.9em;
					   color: rgba(0, 0, 0, 0.54);
				   }

				   .align-right {
					   text-align: right;
				   }
							 `
						 ]
					 })
export class DashboardCombiListComponent extends DashboardPanelComponentBase<DashboardCombiDataIndicatorMeta> implements OnInit {
	name: string;

	constructor(@Inject(forwardRef(() => PopoverRef)) popover: PopoverRef<DashboardCombiDataIndicator>) {
		super();
		this.data = popover.data.meta;
	}

	ngOnInit() {
	}

	update(data: DashboardCombiDataIndicatorMeta): void {
		if (this.data && ArrayUtils.isEqual(this.data, data))
			return;

		this.data = data;
	}

	dataChanged(value: DashboardCombiDataIndicatorMeta) {

	}


}
